/*
 * product-size-spec-table.js
 * Moves the .is-selected highlight in the PDP size-spec table when the variant
 * picker changes. Dawn does NOT re-render the description band on variant change,
 * so the server-rendered .is-selected (correct on first paint) is kept in sync here.
 *
 * Loaded with `defer` from snippets/product-size-spec-table.liquid, which only
 * emits it when custom.size_spec is present — so this runs on that PDP only.
 * Depends on the globals from assets/constants.js + assets/pubsub.js (also
 * deferred, earlier in document order): PUB_SUB_EVENTS and subscribe().
 */
(function () {
  var table = document.querySelector('[data-size-spec-table]');
  if (!table) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  // Scope: only react to variant changes for THIS product's variants.
  var validIds = (table.getAttribute('data-variant-ids') || '')
    .split(',')
    .filter(Boolean);
  var rows = Array.prototype.slice.call(table.querySelectorAll('tr[data-size]'));

  function applySelection(variant) {
    if (!variant || !variant.options) return;
    if (validIds.length && validIds.indexOf(String(variant.id)) === -1) return;

    // Find the row matching the newly selected size. If nothing matches (e.g. a
    // stray event from another product), leave the current highlight untouched.
    var next = null;
    for (var i = 0; i < rows.length; i++) {
      if (variant.options.indexOf(rows[i].getAttribute('data-size')) !== -1) {
        next = rows[i];
        break;
      }
    }
    if (!next) return;

    rows.forEach(function (row) {
      var selected = row === next;
      row.classList.toggle('is-selected', selected);
      if (selected) {
        row.setAttribute('aria-current', 'true');
      } else {
        row.removeAttribute('aria-current');
      }
    });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    applySelection(event && event.data && event.data.variant);
  });
})();
